import { getRequest } from "../utils/api";

export const TagsApi = {
  list: async (limit, offset) =>
    await getRequest(`/tags?limit=${limit}&offset=${offset}`, {}),
};
